export var pluralize = function pluralize(value, wordSingle, wordPlural) {
  if (value === 11) {
    return wordPlural;
  }

  var valueAbs = Math.abs(value).toString();
  return valueAbs.charAt(valueAbs.length - 1) === '1' ? wordSingle : wordPlural;
};